export const QUERY_KEYS = {
  CART: 'cart',
  WISHLIST: 'wishlist',
  COUNT_CART_ITEM: 'count-cart-item',
  CART_MINI: 'cart-mini',
  VOUCHER_IN_CART: 'voucher-in-cart',
  VOUCHER_ONLY_WALLET: 'voucher-only-wallet',
  PROMOTION_PRODUCTS: 'promotion-products',
  USER: 'user',
  COOL_CLUB_MEMBER: 'cool-club-member',
  INVALID_PRODUCT_IN_CART: 'invalid-product-in-cart',
}

export const MUTATION_KEYS = {
  ADD_TO_CART: 'add-to-cart',
  ADD_TO_WISHLIST: 'add-to-wishlist',
  UPDATE_QUANTITY: 'update-quantity',
  REMOVE_CART_ITEM: 'remove-cart-item',
  REMOVE_ALL_CART: 'remove-all-cart',
  APPLY_COOL_CASH: 'apply-cool-cash',
}
